import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsCtypeItem from "./SetsCtypeItem"
import SettingsForm from './SettingsForm'

class SetsCtype extends SettingsForm {

  modelName = 'ctype'

  newItem = {
    ctype_desc: '',
    ctype_active: 1
  };

  render() {
    if(isEmpty(this.props.ctypes.data)){
      return(<div>Не загружены данные</div>);
    }
    const ctypes = this.props.ctypes.data;
    const { search, sort } = this.props.ctypes;
    const { data, errors } = this.state;

    var fltrCtypes = [];
    for(var key in ctypes){
      if(ctypes.hasOwnProperty(key)){
        const active = ctypes[key].ctype_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + ctypes[key].ctype_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrCtypes.push(ctypes[key]);
        }
      }
    }

    const srtCtypes = fltrCtypes.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.ctype_id < b.ctype_id)
         return sort.asc ? -1 : 1
      if(a.ctype_id > b.ctype_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedCtypes = srtCtypes ? srtCtypes.map(ctype =>
      <SetsCtypeItem key={ctype.ctype_id}
        data={ctype}
      />
    ) : [];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.ctype_desc}
              name="ctype_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка типов контрагентов</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrCtypes.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th onClick={() => {this.handleSort('ctype_desc')}}>Название</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedCtypes}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    ctypes: store.ctypes
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsCtype);



// WEBPACK FOOTER //
// ./src/components/settings/SetsCtype.js